/** @format */

import React, {useState} from "react";
import { SlideToggleSwitch } from "mydnv/components/slider-toggle-switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const SubscriptionToggleCards = ({
    cardTitle,
    cardDescription,
    cardToggleState,
    setToggleState,
    childComponent,
    cardIcon,
    cardInfo,
    cbId,
}) => {
    const [fromToggleBtn, setFromToggleBtn] = useState(true);
    const handleToggleState = (e) => {
        const targetNodeName = e.target.nodeName;
        // console.log("card: ", targetNodeName);
        // make sure it's not coming from toggle switch
        if(targetNodeName.toLowerCase() !== "label" && targetNodeName.toLowerCase() !== "input" && targetNodeName.toLowerCase() !== "i"){
            setToggleState(!cardToggleState);
        }
        
    };

    return (
        <>
            <div className={`cardContainer border-${cardToggleState ? "on" : "off"}`} onClick={handleToggleState}>
                <div className={`justify-content-space-between subscribe-${cardToggleState ? "on" : "off"}`}>
                    <FontAwesomeIcon icon={cardIcon} size="xl" />
                    <div className="cardSwitchAndDesc">
                        <SlideToggleSwitch
                            toggleState={cardToggleState}
                            setToggleState={setToggleState}
                            checkBoxId={cbId}
                            setFromBtn={setFromToggleBtn}
                            fromBtn={fromToggleBtn}

                        />
                    </div>
                </div>
                <div className="cardTitle">{cardTitle}</div>

                <div className="cardInfo">{cardInfo}</div>

                {cardToggleState && childComponent && <div className="cardChildComponent">{childComponent}</div>}
            </div>
        </>
    );
};
